import React from "react";
import styles from "./FAQSection.module.css";
import { Container } from "../../common/Container";
import { faqData } from "../../../data/compassData";

export const FAQSection: React.FC = () => (
  <section id="faq" className={styles.section} aria-labelledby="faq-title">
    <Container maxWidth="md">
      <div className={styles.header}>
        <h2 id="faq-title" className={styles.title}>
          Questions, answered
        </h2>
        <p className={styles.subtitle}>
          Still stuck? Email{" "}
          <a href="mailto:dixonappdevelopment@gmail.com" className={styles.link}>
            dixonappdevelopment@gmail.com
          </a>{" "}
          and you'll hear back from the developer.
        </p>
      </div>

      <div className={styles.list}>
        {faqData.map((faq) => (
          <details key={faq.id} id={`faq-${faq.id}`} className={styles.item}>
            <summary className={styles.question}>
              <span>{faq.question}</span>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
                className={styles.chevron}
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            </summary>
            <p className={styles.answer}>{faq.answer}</p>
          </details>
        ))}
      </div>
    </Container>
  </section>
);
